import { useState, useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { getOtaBundleVersion, getCodename } from "@/lib/ota-version";

/**
 * Displays the OTA bundle version at the bottom of a page.
 * Shows "v1.0.42 · Serene Canyon" on OTA builds, "Store Build" on native bundle, nothing on web.
 * Returns null until async version fetch completes to avoid layout shift.
 */
export function OtaVersionBadge() {
  const [label, setLabel] = useState<string | null>(null);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;
    getOtaBundleVersion()
      .then((v) => {
        setLabel(!v || v === "native" ? "Store Build" : `v${v} · ${getCodename(v)}`);
      })
      .catch(() => {});
  }, []);

  if (!label) return null;

  return (
    <div className="text-center text-[10px] text-muted-foreground/50 font-mono py-1 select-none pointer-events-none">
      {label}
    </div>
  );
}
